import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from "@nuxtjs/composition-api";

import { useAuth, useVuetify } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationBanner',
  setup(__props) {

const vuetify = useVuetify();
const store = useStore();
const auth = useAuth();
function onSignUpClick() {
  getAmplitudeStore(store).setReferringComponent("sign up banner");
}
const showBanner = computed(() => {
  return !auth.loggedIn && vuetify.breakpoint.xsOnly && vuetify.breakpoint.width !== 0;
});

return { __sfc: true,vuetify, store, auth, onSignUpClick, showBanner }
}

})